import React from "react";

export default function ProductWrapper({ children }) {
  return <div className="productWrapper">{children}</div>;
}
